import { useMemo } from "react";
import {
  faTag,
  faBookBookmark,
  faPencil,
  faPlayCircle,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../Context/AuthContext";
import { publicUrls } from "../Api/Auth/AppUrls";

// Static feature configuration - keeping original links
const mechanicalFeatureConfig = [
  {
    icon: faTag,
    title: "Live Class",
    link: publicUrls.LiveClassMechanical,
    slugPattern: "live-class",
  },
  {
    icon: faBookBookmark,
    title: "Quiz Bank",
    link: publicUrls.quizBankMechanical,
    slugPattern: "quiz-bank",
  },
  {
    icon: faPencil,
    title: "Simulator",
    link: publicUrls.simulatorMechanical,
    slugPattern: "simulator",
  },
  {
    icon: faPlayCircle,
    title: "Free Model Test",
    link: publicUrls.FreeFeTestMechanical,
    slugPattern: "free-fe-model-test",
  },
  {
    icon: faTag,
    title: "Free FE Material",
    link: publicUrls.FreeFeMaterialsMechanical,
    slugPattern: "free-fe-materials",
  },
  {
    icon: faTag,
    title: "Paid Model Test",
    link: publicUrls.PaidModelTestMechanical,
    slugPattern: "paid-model-test",
  },
  {
    icon: faUser,
    title: "1 to 1 Tutoring",
    link: publicUrls.tutoringMechanical,
    slugPattern: "tutoring",
  },
  {
    icon: faTag,
    title: "Subscription for FE Exam Material",
    link: publicUrls.feSubscriptionMechanical,
    slugPattern: "subscription-materials",
  },
  {
    icon: faTag,
    title: "Practice Hub",
    link: publicUrls.practiceHubMechanical,
    slugPattern: "practice-hub",
  },
];

const civilFeatureConfig = [
  {
    icon: faTag,
    title: "Live Class",
    link: publicUrls.LiveClassCivil,
    slugPattern: "live-class",
  },
  {
    icon: faBookBookmark,
    title: "Quiz Bank",
    link: publicUrls.quizBankCivil,
    slugPattern: "quiz-bank",
  },
  {
    icon: faPencil,
    title: "Simulator",
    link: publicUrls.simulatorCivil,
    slugPattern: "simulator",
  },
  {
    icon: faPlayCircle,
    title: "Free Model Test",
    link: publicUrls.FreeFeTestCivil,
    slugPattern: "free-fe-model-test",
  },
  {
    icon: faTag,
    title: "Free FE Material",
    link: publicUrls.FreeFeMaterialsCivil,
    slugPattern: "free-fe-materials",
  },
  {
    icon: faTag,
    title: "Paid Model Test",
    link: publicUrls.PaidModelTestCivil,
    slugPattern: "paid-model-test",
  },
  {
    icon: faUser,
    title: "1 to 1 Tutoring",
    link: publicUrls.tutoringCivil,
    slugPattern: "tutoring",
  },
  {
    icon: faTag,
    title: "Subscription for FE Exam Material",
    link: publicUrls.feSubscriptionCivil,
    slugPattern: "subscription-materials",
  },
  {
    icon: faTag,
    title: "Practice Hub",
    link: publicUrls.practiceHubCivil,
    slugPattern: "practice-hub",
  },
];

const categoryConfigs = {
  mechanical: mechanicalFeatureConfig,
  civil: civilFeatureConfig,
};

export const useCategoryFeatures = (categoryTitle) => {
  const { categoryData } = useAuth();

  const features = useMemo(() => {
    // Find the matching category
    const category = categoryData?.find(
      (cat) => cat.title.toLowerCase() === categoryTitle.toLowerCase()
    );

    if (!category?.courses) return [];

    // Get the static config for this category
    const config = categoryConfigs[categoryTitle.toLowerCase()];
    if (!config) return [];

    // Map config to features by matching slug patterns
    return config
      .map((feature) => {
        // Find matching course by slug pattern
        const course = category.courses.find((c) =>
          c.slug.includes(feature.slugPattern)
        );

        // Only include if course exists and is visible
        if (!course || course.visibility === false) return null;

        return {
          ...feature,
          title: course.displayTitle || course.title || feature.title,
          id: course._id,
          visibility: course.visibility,
        };
      })
      .filter(Boolean); // Remove null entries
  }, [categoryData, categoryTitle]);

  return features;
};
